// extracted by mini-css-extract-plugin
export default {"wrap":"create_wrap__0LEb3"};